
import { Ref, computed, defineComponent, ref } from 'vue'
import { IdfButton, IdfLoader, IdfAlert } from '@invivodf/ui-kit'
import { IdfAlertComponent } from '@/retail/application/types/IdfAlertComponent.types'
import { useClient } from '../../composables/useClient'
import CustomerInfo from '../../components/CustomerInfo.vue'
import DeleteCustomerModal from '../../components/DeleteCustomerModal.vue'
import { User } from '../../services/user.service'
import FsAccordion from '../../components/organism/FsAccordion.vue'

export default defineComponent({
  name: 'VCustomerFile',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: { IdfLoader, IdfButton, CustomerInfo, FsAccordion, IdfAlert, DeleteCustomerModal },
  setup(props) {
    const { getUserById, updateCustomer, deleteCustomer } = useClient()
    const isLoading = ref(true)
    const customerInfo: Ref<User> = ref({} as User)
    const creationDate = computed(() => {
      if (!customerInfo.value.createdAt) return ''
      return new Date(customerInfo.value.createdAt).toLocaleDateString('fr-FR')
    })

    const alertBanner: Ref<IdfAlertComponent | undefined> = ref<IdfAlertComponent>()

    const alertText = ref('')
    const alertKind = ref('success')
    const alertIcon = ref('')

    const isUpdateModalVisible = ref(false)
    const isDeleteCustomerModalVisible = ref(false)

    const toggleUpdateModalVisible = (): void => {
      isUpdateModalVisible.value = !isUpdateModalVisible.value
    }

    const updateCustomerInfo = (updatedCustomerInfo: User) => {
      const customerId = customerInfo.value.id
      if (!customerId) return
      updateCustomer(customerId, updatedCustomerInfo)
        .then((result) => {
          customerInfo.value = result
          alertText.value = 'Les informations ont bien été mises à jour'
          alertKind.value = 'success'
          alertIcon.value = 'check-outlined'
        })
        .catch(() => {
          alertText.value = 'Une erreur est survenue lors de la mise à jour des informations'
          alertKind.value = 'error'
          alertIcon.value = 'error-outlined'
        })
        .finally(() => {
          alertBanner.value?.show()
        })
      isUpdateModalVisible.value = false
    }

    const onDeleteCustomerFileButtonClick = () => {
      isDeleteCustomerModalVisible.value = true
    }

    const toggleDeleteCustomerModalVisible = () => {
      isDeleteCustomerModalVisible.value = !isDeleteCustomerModalVisible.value
    }

    const deleteCustomerFile = () => {
      const customerId = customerInfo.value.id
      if (!customerId) return
      deleteCustomer(customerId)
        .then(() => {
          alertText.value = 'La fiche client a bien été supprimée'
          alertKind.value = 'success'
          alertIcon.value = 'check-outlined'
        })
        .catch(() => {
          alertText.value = 'Une erreur est survenue lors de la suppression de la fiche client'
          alertKind.value = 'error'
          alertIcon.value = 'error-outlined'
        })
        .finally(() => {
          alertBanner.value?.show()
        })
      isDeleteCustomerModalVisible.value = false
    }

    getUserById(props.id)
      .then((result) => {
        customerInfo.value = result
        isLoading.value = false
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e)
      })

    return {
      customerInfo,
      creationDate,
      updateCustomerInfo,
      onDeleteCustomerFileButtonClick,
      isUpdateModalVisible,
      isDeleteCustomerModalVisible,
      toggleUpdateModalVisible,
      toggleDeleteCustomerModalVisible,
      deleteCustomerFile,
      alertText,
      alertKind,
      alertIcon,
      alertBanner,
      isLoading,
    }
  },
})
